import { baseURL, fetch, postFile } from "./fetch";

export default class BaseApi {
  getBaseURL = () => baseURL;
  // url
  // type =  GET || POST
  // config { data, params, headers }
  request = (url, type = "GET", config = {}) =>
    fetch(url, type, config).then((res) => res.data);
  requestFile = (url, type = "GET", config = {}, customerName) => {
    config.responseType = "blob";

    fetch(url, type, config)
      .then((res) => {
        if (!res) return;
        function exportFile(data, name) {
          let reader = new FileReader();
          reader.readAsDataURL(data);
          reader.onload = (e) => {
            let a = document.createElement("a");
            a.download = name;
            a.href = e.target.result;
            a.target = "_blank";
            document.body.appendChild(a);
            a.click();
            document.body.removeChild(a);
          };
        }
        let fileName = customerName ? customerName : "unknown";
        let contentDisposition = res.headers["content-disposition"];
        if (contentDisposition) {
          let results = window
            .decodeURI(res.headers["content-disposition"])
            .split(";");
          results.forEach((entryStr) => {
            var entry = entryStr.trim().split("=");
            if (entry[0] == "filename" && !customerName) {
              fileName = entry[1].replace('"', "").replace('"', "");
            }
          });
        }
        exportFile(res.data, fileName);
      })
      .catch((err) => {});
  };

  upload = (url, data, config) => postFile(url, data, config);
}
